module.exports = __webpack_public_path__ + "img/ia-05-1.62a0fbc0.jpg";